import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Divider, Flex, Gutter, Icon, Tag } from '@gaiads/telia-react-component-library';
import { UserGroupResponse, UserResponse } from '@cdaas/api-clients/dist/asset-admin-openapi';

import EditAdministrator from '../EditAdministrator/EditAdministrator';
import { UserResponseWithUserGroup, WithKey } from '../../../../utils';

import styles from './AdministratorItem.module.scss';

export function AdministratorItem({
  administrator,
  userGroups,
  currency,
  onAdminUpdate,
  onGroupCreate,
}: {
  administrator: WithKey<UserResponseWithUserGroup>;
  userGroups: UserGroupResponse[];
  currency: string;
  onAdminUpdate: (administrator: UserResponse) => void;
  onGroupCreate: (group: UserGroupResponse) => void;
}) {
  const { t } = useTranslation('organizationForm');
  const [isEditing, setIsEditing] = useState(false);

  const handleUpdate = (administrator: UserResponse) => {
    onAdminUpdate(administrator);
    setIsEditing(false);
  };

  return (
    <div className={styles['customer-organization-form__administrator-item-container']}>
      <div className={styles['customer-organization-form__administrator-item-content-container']}>
        {!isEditing ? (
          <Flex className={styles['customer-organization-form__administator-details-container']} alignBottom>
            <Flex className={styles['customer-organization-form__administator-details']} occupyHorizontalSpace directionColumn>
              <BodyText>
                {!!administrator && administrator.given_name && administrator.family_name ? (
                  `${administrator.given_name} ${administrator.family_name}`
                ) : (
                  <Tag backgroundColor="orange400">{t('administrators.accountNotActivatedBadge')}</Tag>
                )}
              </BodyText>
              <Gutter size="xs" />
              <BodyText>
                {administrator.email}, {administrator.phone_number}
              </BodyText>
              <Gutter size="xs" />
              <BodyText>{administrator.user_group?.name}</BodyText>
            </Flex>
            <Flex centeredHorizontally clickableAppearance onClick={() => setIsEditing(true)} color={'purple500'}>
              <BodyText>{t('administrators.editButton')}</BodyText>
              <Icon name="document-edit" margin={{ left: 'xs', top: 'xxs' }} size="sm"></Icon>
            </Flex>
          </Flex>
        ) : (
          <EditAdministrator
            admin={administrator}
            userGroups={userGroups}
            currency={currency}
            onAdminUpdate={handleUpdate}
            onCancel={() => setIsEditing(false)}
            onGroupCreate={onGroupCreate}
          />
        )}
      </div>
      <Divider />
    </div>
  );
}
